import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const PennsylvaniaMap = ({ onZoneClick }) => {
	const [selectedZone, setSelectedZone] = useState(null);

	const handleZoneClick = (zoneId) => {
		setSelectedZone(zoneId);
		if (onZoneClick) {
			onZoneClick(zoneId);
		}
		console.log('Zone Clicked: %s', zoneId);
	};

	return (
		<svg
			id='pennsylvania'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 1000 1000'
			className='map'>
			<polygon
				id='PA_ZS'
				points='844.85 495.61 833.1 518.91 838.51 540.21 887.52 604.35 847.09 635.42 835.72 652.62 807.89 670.8 803.78 654.76 777.18 660.96 765.07 682.09 733.68 681.28 661.74 685.07 479.17 687.42 181.06 687.41 184.56 493.73 844.85 495.61'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'PA_ZS' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('PA_ZS')}
			/>
			<polygon
				id='PA_ZN'
				points='844.85 495.61 840.25 471.34 858.07 452.31 865.63 428.29 883.45 409.25 853.95 387.51 840.09 358.38 807.98 312.66 791.45 308.54 598.75 316.11 339.7 319.37 271.74 318.45 281.76 265.11 224.71 297.78 187.84 312.55 184.56 493.73 844.85 495.61'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'PA_ZN' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('PA_ZN')}
			/>
			<rect
				x='488.27'
				y='552.63'
				width='59.85'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M487.66,592.15l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M522.15,588.97c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.69-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<rect
				x='403.13'
				y='375.59'
				width='73.15'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M402.51,415.11l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M436.38,418.19l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
			<polygon
				points='836.8 615.72 836.91 620.04 841.45 620.04 836.97 622.71 837.08 627.04 834.2 624.36 829.72 627.04 832.43 622.71 829.55 620.04 834.1 620.04 836.8 615.72'
				className='shape'
			/>
			<rect x='687.43' y='591' width='148.1' height='20' fill='none' className='shape' />
			<path
				d='M691.22,592.1c.91-.21,2.2-.35,3.5-.35,1.56,0,3.06.38,3.96,1.25.76.71,1.17,1.65,1.17,2.93,0,1.8-.89,3.33-1.94,4.21-1.25,1.05-3.08,1.55-4.9,1.55-.61,0-1.14-.04-1.65-.13l-1.23,6.48h-1.96l3.04-15.94ZM691.68,599.88c.56.12,1.02.16,1.61.16,2.73,0,4.56-1.7,4.56-3.97,0-1.93-1.37-2.69-3.22-2.69-.79,0-1.39.07-1.74.17l-1.21,6.33Z'
				className='shape'
			/>
			<path
				d='M702.59,608.04l3.24-17.04h1.99l-1.45,7.48h.05c1-1.41,2.4-2.31,4.15-2.31,1.32,0,2.89.8,2.89,3.11,0,.62-.08,1.38-.19,1.96l-1.29,6.8h-1.99l1.27-6.71c.08-.42.16-.96.16-1.6,0-1.07-.51-1.91-1.8-1.91-1.54,0-3.47,1.8-3.95,4.4l-1.08,5.82h-1.99Z'
				className='shape'
			/>
			<path
				d='M717.83,608.04l2.22-11.61h1.99l-2.22,11.61h-1.99ZM720.41,593.19c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path d='M725.75,608.04l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M741.36,608.04c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM742.65,597.92c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M760.96,591l-2.55,13.36c-.22,1.2-.42,2.56-.49,3.68h-1.82l.31-2.3h-.05c-1.06,1.65-2.52,2.56-4.19,2.56-2.24,0-3.47-1.84-3.47-4.22,0-4.13,3.07-7.91,7.18-7.91.73,0,1.55.16,2.05.4l1.04-5.57h1.98ZM757.62,598.25c-.4-.27-1.07-.49-1.9-.49-2.79,0-4.95,2.97-4.95,6.05,0,1.4.48,2.86,2.19,2.86,1.53,0,3.38-1.75,3.88-4.36l.78-4.06Z'
				className='shape'
			/>
			<path
				d='M772.01,607.38c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM769.81,597.72c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path d='M776.94,608.04l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M783.81,612.79l2.32-12.25c.26-1.4.5-2.94.65-4.11h1.82l-.33,2.19h.05c1.05-1.53,2.58-2.45,4.18-2.45,2.52,0,3.58,2.06,3.58,4.19,0,4.09-2.93,7.94-6.8,7.94-1.23,0-2.05-.27-2.5-.52h-.05l-.94,5.01h-1.98ZM787.08,606.1c.51.4,1.27.64,2.22.64,2.57,0,4.71-3.19,4.71-6.22,0-1.22-.54-2.69-2.23-2.69-1.57,0-3.51,1.78-4.12,5.03l-.59,3.24Z'
				className='shape'
			/>
			<path
				d='M799.88,608.04l3.24-17.04h1.99l-1.45,7.48h.05c1-1.41,2.4-2.31,4.15-2.31,1.32,0,2.89.8,2.89,3.11,0,.62-.08,1.38-.19,1.96l-1.29,6.8h-1.99l1.27-6.71c.08-.42.16-.96.16-1.6,0-1.07-.51-1.91-1.8-1.91-1.54,0-3.47,1.8-3.95,4.4l-1.08,5.82h-1.99Z'
				className='shape'
			/>
			<path
				d='M815.12,608.04l2.22-11.61h1.99l-2.22,11.61h-1.99ZM817.71,593.19c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M830.74,608.04c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM832.03,597.92c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<polygon
				points='243.36 550.85 243.46 555.18 248.01 555.18 243.53 557.85 243.64 562.17 240.76 559.5 236.28 562.17 238.98 557.85 236.11 555.18 240.65 555.18 243.36 550.85'
				className='shape'
			/>
			<rect x='248.01' y='532.63' width='109.56' height='20' fill='none' className='shape' />
			<path
				d='M251.79,533.73c.91-.21,2.2-.35,3.5-.35,1.56,0,3.06.38,3.96,1.25.76.71,1.17,1.65,1.17,2.93,0,1.8-.89,3.33-1.94,4.21-1.25,1.05-3.08,1.55-4.9,1.55-.61,0-1.14-.04-1.65-.13l-1.23,6.48h-1.96l3.04-15.94ZM252.26,541.51c.56.12,1.02.16,1.61.16,2.73,0,4.56-1.7,4.56-3.97,0-1.93-1.37-2.69-3.22-2.69-.79,0-1.39.07-1.74.17l-1.21,6.33Z'
				className='shape'
			/>
			<path
				d='M263.02,549.67l2.22-11.61h1.99l-2.22,11.61h-1.99ZM265.6,534.82c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.79-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M276.13,534.94l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.13,1.1,1.13.36,0,.68-.03.94-.09l-.1,1.57c-.35.13-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M286.07,534.94l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.13,1.1,1.13.36,0,.68-.03.94-.09l-.1,1.57c-.35.13-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M290.9,547.65c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.9,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.96,1.29.73,2.17,1.74,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M307.3,532.63l-1.53,7.53h.05c1.03-1.55,2.52-2.36,4.08-2.36,2.54,0,3.52,2.1,3.52,4.16,0,3.57-2.58,7.98-7.23,7.98-2.04,0-3.58-.85-3.58-2.99,0-.57.1-1.25.2-1.8l2.5-12.51h1.99ZM304.78,545.18c-.08.39-.15.86-.14,1.47.01,1.1.64,1.71,1.88,1.71,3.01,0,4.82-3.57,4.82-6.15,0-1.44-.63-2.77-2.22-2.77-1.71,0-3.5,1.78-4.08,4.5l-.26,1.23Z'
				className='shape'
			/>
			<path
				d='M328.53,538.06l-1.56,8.23c-.24,1.29-.41,2.42-.52,3.38h-1.8l.3-2.19h-.05c-1.03,1.51-2.56,2.46-4.1,2.46s-3.07-.72-3.07-3.36c0-.56.07-1.19.22-1.95l1.25-6.56h1.99l-1.23,6.47c-.12.65-.2,1.2-.2,1.7,0,1.2.49,2.02,1.85,2.02,1.45,0,3.3-1.69,3.78-4.24l1.13-5.95h1.99Z'
				className='shape'
			/>
			<path
				d='M332.25,549.67l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.79l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M342.22,552.3c.71.45,1.86.76,3.08.76,1.95,0,3.48-.99,4.17-4.13l.38-1.74h-.06c-1.02,1.66-2.43,2.47-4.04,2.47-2.33,0-3.53-1.96-3.54-4.02,0-3.95,2.88-7.84,7.37-7.84,1.35,0,2.81.38,3.73.81l-1.78,9.59c-.47,2.46-1.13,4.16-2.34,5.2-1.16,1-2.73,1.29-4.05,1.29-1.41,0-2.75-.33-3.48-.82l.56-1.56ZM351.14,539.79c-.37-.18-1.09-.4-1.92-.4-2.9,0-4.9,3.04-4.92,5.9,0,1.29.46,2.78,2.22,2.78s3.44-2.16,3.87-4.42l.74-3.87Z'
				className='shape'
			/>
			<polygon
				points='788.67 506.84 788.78 511.17 793.33 511.17 788.85 513.84 788.96 518.16 786.08 515.49 781.6 518.16 784.3 513.84 781.43 511.17 785.97 511.17 788.67 506.84'
				className='shape'
			/>
			<rect x='660.98' y='513.1' width='120.92' height='20' fill='none' className='shape' />
			<path
				d='M665.01,525.02l-2.57,5.12h-2.1l8.36-16.18h2.35l2.24,16.18h-2.04l-.65-5.12h-5.58ZM670.45,523.44l-.63-4.67c-.09-.84-.21-2.03-.29-2.98h-.06c-.43.96-.83,1.97-1.32,2.95l-2.41,4.7h4.71Z'
				className='shape'
			/>
			<path d='M677.75,530.14l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path d='M685.67,530.14l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M701.95,529.47c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM699.75,519.82c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M706.88,530.14l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M727.31,515.41l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.12,1.1,1.12.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M743.1,523.1c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM734.17,525.56c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M749.49,518.53l.41,6.53c.09,1.44.08,2.18.06,3.12h.05c.28-.76.7-1.75,1.27-2.91l3.45-6.74h1.73l.73,6.61c.12,1.28.2,2.27.18,3.04h.06c.31-.94.63-1.83,1.1-2.95l3.13-6.7h2.03l-5.74,11.61h-1.85l-.77-6.31c-.11-1.08-.18-2.07-.17-3.09h-.05c-.49,1.12-.82,2-1.35,3.03l-3.33,6.37h-1.86l-1.07-11.61h1.96Z'
				className='shape'
			/>
			<path
				d='M766.13,530.14l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<polygon
				points='763.36 383.81 763.46 388.14 768.01 388.14 763.53 390.81 763.64 395.13 760.76 392.46 756.28 395.13 758.98 390.81 756.11 388.14 760.65 388.14 763.36 383.81'
				className='shape'
			/>
			<rect x='654.8' y='365.59' width='106.68' height='20' fill='none' className='shape' />
			<path
				d='M655.8,380.13c.88.59,2.09,1.03,3.44,1.03,1.82,0,3.5-1.09,3.5-3.04,0-1.2-.68-2.1-2.37-3.02-2.07-1.12-3.22-2.41-3.22-4.15,0-2.89,2.49-4.75,5.46-4.75,1.58,0,2.76.46,3.31.84l-.71,1.63c-.51-.3-1.52-.77-2.81-.76-2,0-3.2,1.32-3.21,2.64,0,1.31.82,2.06,2.51,3,1.99,1.07,3.09,2.34,3.09,4.33,0,2.8-2.2,5-5.84,5-1.62,0-3.21-.53-3.89-1.12l.72-1.63Z'
				className='shape'
			/>
			<path
				d='M677.32,382.17c-.59.29-1.79.71-3.37.71-2.99,0-4.46-2.02-4.46-4.49,0-3.96,2.95-7.63,7.12-7.63,1.08,0,2.06.32,2.41.53l-.57,1.58c-.46-.22-1.1-.44-1.97-.44-3.01,0-4.92,2.97-4.92,5.71,0,1.89.99,3.1,2.89,3.1,1.18,0,2.09-.36,2.68-.65l.19,1.57Z'
				className='shape'
			/>
			<path
				d='M681.93,382.63l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.79l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M699.33,382.63c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM700.62,372.51c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M706.63,382.63l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M727.06,367.9l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.12,1.1,1.12.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M742.85,375.58c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM733.92,378.05c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M746.66,382.63l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<polygon
				points='239.11 296.94 239.22 301.27 243.76 301.27 239.28 303.94 239.39 308.26 236.51 305.59 232.03 308.26 234.74 303.94 231.86 301.27 236.41 301.27 239.11 296.94'
				className='shape'
			/>
			<rect x='201.78' y='313.79' width='46.22' height='20' fill='none' className='shape' />
			<path
				d='M211.84,323.23h-5.88l-1.12,5.9h6.62l-.33,1.7h-8.61l3.08-16.18h8.24l-.33,1.7h-6.24l-.99,5.18h5.89l-.33,1.69Z'
				className='shape'
			/>
			<path
				d='M216.12,330.83l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.78l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M226.15,330.83l2.22-11.61h1.99l-2.22,11.61h-1.99ZM228.74,315.98c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M242.44,330.17c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM240.24,320.51c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
		</svg>
	);
};

PennsylvaniaMap.propTypes = {
	onZoneClick: PropTypes.func.isRequired,
	selectedZone: PropTypes.string,
};

export default PennsylvaniaMap;
